(function() {
    const sliders = document.querySelectorAll('[data-component="video-carousel"]');

    if (!sliders) {
        return;
    }

    sliders.forEach((slider) => {
        const slider_videos = slider.querySelector('.c-video-list__multiple');
        const videos = slider_videos.querySelectorAll('.c-video');
        const totalVideos = videos.length;
        let currentIndex = 0;

        const prevBtn = slider.querySelector('.c-video-carousel__btn--prev');
        const nextBtn = slider.querySelector('.c-video-carousel__btn--next');
        const dotsContainer = slider.querySelector('.js-carousel-dots');

        const getVideoWidth = () => {
            const videoElement = slider_videos.querySelector('.c-video');
            if (!videoElement) {
                return 320;
            }
            const videoWidth = videoElement.offsetWidth;
            const gap = parseFloat(window.getComputedStyle(slider_videos).columnGap) || 0;
            return videoWidth + gap;
        };

        const updateButtonState = () => {
            prevBtn.disabled = currentIndex === 0;
            nextBtn.disabled = currentIndex === totalVideos - 1;
        };

        const updateDots = () => {
            const dots = dotsContainer.querySelectorAll('.c-video-carousel__dot');
            dots.forEach((dot, index) => {
                dot.classList.toggle('c-video-carousel__dot--active', index === currentIndex);
            });
        };

        const scrollVideos = (direction) => {
            const videoWidth = getVideoWidth();
            currentIndex += direction;
            if (currentIndex < 0) {
                currentIndex = 0;
            } else if (currentIndex >= totalVideos) {
                currentIndex = totalVideos - 1;
            }

            const newPosition = -currentIndex * videoWidth;
            slider_videos.style.transform = `translateX(${newPosition}px)`;

            updateButtonState();
            updateDots();
        };

        const scrollToVideo = (index) => {
            const videoWidth = getVideoWidth();
            const newPosition = -index * videoWidth;
            slider_videos.style.transform = `translateX(${newPosition}px)`;

            currentIndex = index;
            updateButtonState();
            updateDots();
        };

        videos.forEach((_, index) => {
            const dot = document.createElement('span');
            dot.classList.add('c-video-carousel__dot');
            if (index === 0) {
                dot.classList.add('c-video-carousel__dot--active');
            }
            dot.dataset.index = index;
            dot.addEventListener('click', () => scrollToVideo(index));
            dotsContainer.appendChild(dot);
        });

        prevBtn.addEventListener('click', () => scrollVideos(-1));
        nextBtn.addEventListener('click', () => scrollVideos(1));

        slider_videos.style.transform = `translateX(0px)`;
        updateButtonState();
        updateDots();
    });
})();
